module.exports = __webpack_public_path__ + "static/img/101853.a36e62f7.png";